module.exports = __webpack_public_path__ + "img/jsps.7061192a.png";